export default {
  API_URL: process.env.API_BASE_URL || process.env.REACT_APP_API_BASE_URL,
  API_STATIC_AUTHORIZATION_TOKEN: process.env.API_STATIC_AUTHORIZATION_TOKEN || process.env.REACT_APP_API_STATIC_AUTHORIZATION_TOKEN,
  GOOGLE_API_KEY: process.env.GOOGLE_API_KEY || process.env.REACT_APP_GOOGLE_API_KEY,
  IUBENDA_API_KEY: process.env.IUBENDA_API_KEY || process.env.REACT_APP_IUBENDA_API_KEY,
  POLICY_BASE_URL: process.env.POLICY_BASE_URL || process.env.REACT_APP_POLICY_BASE_URL,
  AIR_MYPAGE_URL: process.env.AIR_MYPAGE_URL || process.env.REACT_APP_AIR_MYPAGE_URL,
};
